import { memo } from 'react';
import { OnlinePurchase, TelepresencePurchase } from '../';
import {
  useGetComponentParameters,
  useGetComponentParametersSingle
} from '../../../Core/Hooks/HooksParameters/useGetComponentParameters';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';
import { COURSE_MODE, TYPE_FETCH_PARAMETERS } from '../../../Domain/Settings/Constants/Constants';
import { useCombinedObjects } from '../../../Domain/Utils/ApiUtilies/Parameters/Parameters';

const FirstCourseModeOption = (props) => {
  const scheduler = props?.schedulerListCourse;
  const isOnline = props?.courseItem?.mode[0]?.code == COURSE_MODE.ONLINE;
  const modeId = parseInt(props?.courseItem?.mode?.[0]?.code);
  const parametersMlt = useGetComponentParameters(COMPONENTS.COURSE_CARD_BUY);
  const parametersStd = useGetComponentParametersSingle(
    COMPONENTS.COURSE_CARD_BUY,
    TYPE_FETCH_PARAMETERS.STANDARD
  );
  const parameters = useCombinedObjects(parametersMlt, parametersStd);
  return (
    <>
      {isOnline ? (
        <OnlinePurchase {...{ props, scheduler, modeId, parameters }} />
      ) : (
        <TelepresencePurchase {...{ props, scheduler, modeId, parameters }} />
      )}
    </>
  );
};

export default memo(FirstCourseModeOption);
